import Vue from 'vue';
import Axios from 'axios';

export default Vue.extend({
    data () {
      return {
        subjects: [
          // {
          //   sub_name: 'Data Science',
          //   percentage: 78,
          // },
          // {
          //   sub_name: 'Programming',
          //   percentage: 70,
          // },
          // {
          //   sub_name: 'Networking',
          //   percentage: 82,
          // },
          // {
          //   sub_name: 'Analytical Ability',
          //   percentage: 69,
          // },
          // {
          //   sub_name: 'English',
          //   percentage: 93,
          // },
         
        ],
      }
    },

    created(){
      this.initialize()
    },

    methods: {
      initialize() {
        
        Axios.get('https://yqroi4mbbd.execute-api.us-east-1.amazonaws.com/prod/admin-panel-info')
        .then(response => {
          if(!response.data.error){
            
            this.avgScore = response.data.data.avg_score_per;
         
            this.subjects = [
              {
                
                sub_name: 'Programming & Data Structure',
                percentage: response.data.data.avgBySub[0].average_score,
              },
              {
               
                sub_name: 'Data Science',
                percentage: response.data.data.avgBySub[1].average_score,
              },
              {
                
                sub_name: 'Networking & Cyber Security',
                percentage: response.data.data.avgBySub[2].average_score,
              },
              {
               
                sub_name: 'Analytical Ability',
                percentage: response.data.data.avgBySub[3].average_score,
              },
              {
                
                sub_name: 'English',
                percentage: response.data.data.avgBySub[4].average_score,
              },
            ]
          }
        })
      }
    }
  })
